import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getRFQreportslist } from "../../../store/Reports/actions";
import LoadingModel from "../../LoadingModel";
import "./rfq.scss";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class RFQReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getRFQreportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  componentDidUpdate(){
    console.log("RFQ Report List Updated", this.props.RFQ_ReportData);
  }

  GetLiveTime(startDate) {
    var ms = this.state.now.diff(moment(startDate));
    var d = moment.duration(ms);
    var mmss = moment.utc(ms).format("mm");
    return Math.floor(d.asHours()) + " Hrs " + mmss + " mm";
  }
  GetDuraction(startDate, EndDate) {
    var ms = moment(EndDate).diff(moment(startDate));
    var d = moment.duration(ms);
    var mmss = moment.utc(ms).format("mm:ss");
    return Math.floor(d.asHours()) + " Hrs " + mmss + " mm";
  }
  isTimeExpired = (createdOn) => {
    const hoursPassed = moment
      .duration(moment().diff(moment(createdOn)))
      .asHours();

    return hoursPassed >= this.props.RFQrowdata.hr;
  };

  getQuotationDuration = (vend) => {
    if (
      vend.loginstatus === 2 &&
      vend.quotation_createdon &&
      vend.quotation_createdon !== "None"
    ) {
      return this.GetDuraction(vend.createdon, vend.quotation_createdon);
    }
    return this.GetDuraction(vend.createdon, this.state.now);
  };

  getElapsedHours = (date) => {
    return moment.duration(moment().diff(moment(date))).asHours();
  };

  getQuotationStatusMeta = (vend, hr) => {
    const elapsedHours = this.getElapsedHours(vend.createdon);
    const isExpired = vend.loginstatus !== 2 && elapsedHours >= hr;

    if (vend.resend) {
      return { text: "Reset", color: "pink" };
    }

    if (vend.loginstatus === 2) {
      return { text: "Quotation Submitted", color: "success" };
    }

    if (isExpired) {
      return { text: "Time Expired", color: "danger" };
    }

    return { text: "Awaiting Vendor Response", color: "warning" };
  };
  getVendorExcelSummary = (rfq) => {
    if (!rfq.rfqvendors?.length) return "-";

    return rfq.rfqvendors
      .map((vend) => {
        const elapsedHours = this.getElapsedHours(vend.createdon);

        const isExpired =
          vend.loginstatus !== 2 && elapsedHours >= rfq.hr && !vend.resend;

        let timeLabel = this.GetDuraction(vend.createdon, this.state.now);

        let status = "Awaiting Vendor";

        if (vend.loginstatus === 2) {
          status = "Submitted";
          timeLabel = this.getQuotationDuration(vend);
        } else if (vend.resend) {
          status = "Reset";
        } else if (isExpired) {
          status = "Time Expired";
          timeLabel = `${timeLabel} (Expired)`;
        }

        return `${vend.vendor?.name}
Time: ${timeLabel}
Status: ${status}`;
      })
      .join("\n\n");
  };

  render() {
    const excelData = this.props.RFQ_ReportData.flatMap((rfq) => {
      const orderLocationNames =
        rfq.orderlocations?.map((loc) => loc.name).join(", ") || "-";

      if (!rfq.rfqvendors?.length) {
        return [
          {
            "RFQ Code": rfq.code,
            "RFQ Date": rfq.date && moment(rfq.date, "YYYY-MM-DD", true).isValid()
              ? moment(rfq.date, "YYYY-MM-DD").format("DD-MM-YYYY")
              : rfq.date || "-",
            Location: rfq.location?.name || "-",
            "Order Locations": orderLocationNames,
            "Item Name": rfq.item_name || "-",
            "Vendor Name": "-",
            "Running Timeout": "-",
            "Vendor Status": "-",
            "Due Days": rfq.due_days,
            "RFQ Status": rfq.rfqstatus_name,
            "Quotation Status": rfq.quotation_status || "Pending",
            "Quotation No": rfq.quotation_no || "-",
            "Quotation Date": rfq.quotation_date
              ? moment(rfq.quotation_date).format("DD-MM-YYYY")
              : "-",
            "Created By": `${rfq.createdby?.fullname || ""} (${
              rfq.createdby?.username || ""
            })`,
          },
        ];
      }

      return rfq.rfqvendors.map((vend, index) => {
        const elapsedHours = this.getElapsedHours(vend.createdon);

        const isExpired =
          vend.loginstatus !== 2 && elapsedHours >= rfq.hr && !vend.resend;

        let timeLabel = this.GetDuraction(vend.createdon, this.state.now);
        let status = "Awaiting Vendor";

        if (vend.loginstatus === 2) {
          status = "Submitted";
          timeLabel = this.getQuotationDuration(vend);
        } else if (vend.resend) {
          status = "Reset";
        } else if (isExpired) {
          status = "Time Expired";
          timeLabel = `${timeLabel} (Expired)`;
        }

        // 👇 show RFQ data ONLY for first vendor row
        const showRFQ = index === 0;

        return {
          "RFQ Code": showRFQ ? rfq.code : "",
          "RFQ Date": showRFQ && rfq.date && moment(rfq.date, "YYYY-MM-DD", true).isValid()
            ? moment(rfq.date, "YYYY-MM-DD").format("DD-MM-YYYY")
            : showRFQ ? (rfq.date || "") : "",
          Location: showRFQ ? rfq.location?.name || "-" : "",
          "Order Locations": showRFQ ? orderLocationNames : "",
          "Item Name": showRFQ ? rfq.item_name || "-" : "",
          "Vendor Name": vend.vendor?.name || "-",
          "Running Timeout": timeLabel,
          "Vendor Status": status,
          "Due Days": showRFQ ? rfq.due_days : "",
          "RFQ Status": showRFQ ? rfq.rfqstatus_name : "",
          "Quotation Status": showRFQ ? rfq.quotation_status || "Pending" : "",
          "Quotation No": showRFQ ? rfq.quotation_no || "-" : "",
          "Quotation Date": showRFQ
            ? rfq.quotation_date
              ? moment(rfq.quotation_date).format("DD-MM-YYYY")
              : "-"
            : "",
          "Created By": showRFQ
            ? `${rfq.createdby?.fullname || ""} (${
                rfq.createdby?.username || ""
              })`
            : "",
        };
      });
    });
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
             {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/rfqreport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={excelData}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "REQUEST FOR QUOTATION REPORT",
                            "",
                          ]}
                          fileName="REQUEST_FOR_QUOTATION_REPORT"
                        />

                        {/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
                        {/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        REQUEST FOR QUOTATION REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(new Date(y, m, 1))).format(
                              "DD-MM-YYYY"
                            )
                          : moment(this.props.params.start_date).format(
                              "DD-MM-YYYY"
                            )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>
                    {/* <div className="Filter-panel-content">
                      <div className="list-column">
                        <Row>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">From Date: </span>
                                <span className="dtl">
                                  {this.props.params.start_date}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">To Date:</span>
                                <span className="dtl">
                                  {this.props.params.end_date}
                                </span>
                              </li>
                            </ul>
                          </Col>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">Locations: </span>
                                <span className="dtl">
                                  {this.props.params.start_date}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Sub Location:</span>
                                <span className="dtl">
                                  {this.props.PIreqRowData?.userdepartment.name}
                                </span>
                              </li>
                            </ul>
                          </Col>
                          <Col md={4}>
                            <ul className="list-style p-0">
                              <li className="clearfix">
                                <span className="ttl">User Department:</span>
                                <span className="dtl">
                                  {this.props.params.end_date}
                                </span>
                              </li>
                            </ul>
                          </Col>
                        </Row>
                      </div>
                    </div> */}
                    {/* <div>
                      <Row>
                        <Col md={6}>
                          <span>From Date:</span>
                          <span>
                            {this.props.params.start_date == null
                              ? "all"
                              : this.props.params.start_date}
                          </span>
                        </Col>
                        <Col md={6}></Col>
                      </Row>
                    </div> */}

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center">
                          <tr>
                            <th>
                              <b>RFQ Code</b>
                            </th>
                            <th>
                              <b>RFQ Date</b>
                            </th>
                            <th>
                              <b>Location</b>
                            </th>
                            <th>
                              <b>Order Locations</b>
                            </th>
                            <th>
                              <b>Item Name</b>
                            </th>
                            <th>
                              <b>Vendors</b>
                            </th>
                            <th>
                              <b>Vendor Names</b>
                            </th>
                            <th>
                              <b>Due Days</b>
                            </th>
                            <th>
                              <b>RFQ Status</b>
                            </th>
                            <th>
                              <b>Quotation Status</b>
                            </th>
                            <th>
                              <b>Quotation No</b>
                            </th>
                            <th>
                              <b>Quotation Date</b>
                            </th>
                            <th>
                              <b>Created By</b>
                            </th>
                          </tr>
                        </thead>

                        <tbody className="text-center">
                          {this.props.RFQ_ReportData?.length ? (
                            this.props.RFQ_ReportData.map((rfq, key) => {
                              const orderLocationNames =
                                rfq.orderlocations
                                  ?.map((loc) => loc.name)
                                  .join(", ") || "-";

                              const vendorNames =
                                rfq.rfqvendors
                                  ?.map((v) => v.vendor?.name)
                                  .join(", ") || "-";

                              return (
                                <tr key={rfq.id || key}>
                                  <td>{rfq.code}</td>

                                  <td>
                                    {rfq.date
                                      ? moment(rfq.date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : "-"}
                                  </td>

                                  <td>{rfq.location?.name || "-"}</td>

                                  <td className="text-left">
                                    {orderLocationNames}
                                  </td>

                                  <td className="text-left">
                                    {rfq.item_name || "-"}
                                  </td>

                                  <td>{rfq.vendors_count}</td>

                                  <td className="text-left">
                                    {rfq.rfqvendors?.length ? (
                                      <ul className="list-unstyled mb-0">
                                        {rfq.rfqvendors.map((vend, index) => {
                                          const elapsedHours =
                                            this.getElapsedHours(
                                              vend.createdon
                                            );

                                          const isExpired =
                                            vend.loginstatus !== 2 &&
                                            elapsedHours >= rfq.hr &&
                                            !vend.resend;

                                          let timeColor = "info";
                                          let timeLabel = this.GetDuraction(
                                            vend.createdon,
                                            this.state.now
                                          );

                                          if (vend.loginstatus === 2) {
                                            timeColor = "success";
                                            timeLabel =
                                              this.getQuotationDuration(vend);
                                          } else if (vend.resend) {
                                            timeColor = "warning";
                                          } else if (isExpired) {
                                            timeColor = "danger";
                                            timeLabel = `${timeLabel} (Expired)`;
                                          }

                                          return (
                                            <li
                                              key={vend.id || index}
                                              className="mb-2"
                                            >
                                              {/* Vendor Name */}
                                              <div>
                                                <strong>
                                                  {vend.vendor?.name}
                                                </strong>
                                              </div>

                                              {/* Running Timeout */}
                                              <div>
                                                <Badge
                                                  color={timeColor}
                                                  className="font-size-12"
                                                >
                                                  {timeLabel}
                                                </Badge>
                                              </div>

                                              {/* Quotation Status */}
                                              <div>
                                                {vend.loginstatus === 2 && (
                                                  <Badge
                                                    color="success"
                                                    className="font-size-12"
                                                  >
                                                    Submitted
                                                  </Badge>
                                                )}

                                                {vend.resend &&
                                                  vend.loginstatus !== 2 && (
                                                    <Badge
                                                      color="pink"
                                                      className="font-size-12"
                                                    >
                                                      Reset
                                                    </Badge>
                                                  )}

                                                {!vend.resend && isExpired && (
                                                  <Badge
                                                    color="danger"
                                                    className="font-size-12"
                                                  >
                                                    Time Expired
                                                  </Badge>
                                                )}

                                                {!vend.resend &&
                                                  !isExpired &&
                                                  vend.loginstatus !== 2 && (
                                                    <Badge
                                                      color="info"
                                                      className="font-size-12"
                                                    >
                                                      Awaiting Vendor
                                                    </Badge>
                                                  )}
                                              </div>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  <td>{rfq.due_days}</td>

                                  <td>
                                    <Badge color="primary">
                                      {rfq.rfqstatus_name}
                                    </Badge>
                                  </td>

                                  <td>
                                    <Badge
                                      color={
                                        rfq.quotation_status === "Quoted"
                                          ? "success"
                                          : "warning"
                                      }
                                    >
                                      {rfq.quotation_status || "Pending"}
                                    </Badge>
                                  </td>

                                  <td>{rfq.quotation_no || "-"}</td>

                                  <td>
                                    {rfq.quotation_date
                                      ? moment(rfq.quotation_date).format(
                                          "DD-MM-YYYY"
                                        )
                                      : "-"}
                                  </td>

                                  <td>
                                    {rfq.createdby?.fullname} (
                                    {rfq.createdby?.username})
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="13" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, RFQ_ReportData, loading } = state.reports;
  return {
    params,
    reportType,
    Reportdata,
    RFQ_ReportData,
    loading
  };
};

export default connect(mapStatetoProps, {
  getRFQreportslist,
})(RFQReportList);
